import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Link from '@mui/joy/Link';
import Sheet from '@mui/joy/Sheet';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Sheet
            component="footer"
            variant="soft"
            sx={{
                py: 1.2,
                px: 1,
                mt: 'auto',
                borderTop: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Box
                sx={{
                    maxWidth: 'lg',
                    mx: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        textAlign: { xs: 'center', sm: 'left' }
                    }}
                >
                    <Typography level="body-sm" sx={{ mb: { xs: 1, sm: 0 } }}>
                        © Copyrights {currentYear} by Vector India
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 1, sm: 2 }
                        }}
                    >
                        <Link
                            href="https://www.vectorindia.org/terms-and-conditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            level="body-sm"
                        >
                            Terms & Conditions
                        </Link>
                        <Link
                            href="https://www.vectorindia.org/privacy-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            level="body-sm"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            href="https://www.vectorindia.org/refund-and-cancellation-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            level="body-sm"
                        >
                            Refund and Cancellation Policy
                        </Link>
                    </Box>
                </Box>
            </Box>
        </Sheet>
    );
};

export default Footer; 